document.addEventListener("DOMContentLoaded", function () {
  // Get all glider containers
  const gliderContainers = document.querySelectorAll(".glider-contain");

  // Initialize each glider instance
  gliderContainers.forEach((container, index) => {
    const glider = container.querySelector(".glider");
    const dots = container.querySelector(".dots");
    const prevButton = container.querySelector(".glider-prev");
    const nextButton = container.querySelector(".glider-next");

    if (glider) {
      new Glider(glider, {
        slidesToShow: 1,
        dots: dots,
        scrollLock: true,
        arrows: {
          prev: prevButton,
          next: nextButton,
        },
      });
    }
  });

  // Smooth scrolling for navigation links
  const navLinks = document.querySelectorAll('.main-nav .nav-link[href^="#"]');

  navLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();

      const targetId = this.getAttribute("href").substring(1);
      const targetSection = document.getElementById(targetId);

      if (targetSection) {
        const headerHeight = document.querySelector("header").offsetHeight;
        const targetPosition = targetSection.offsetTop - headerHeight;

        window.scrollTo({
          top: targetPosition,
          behavior: "smooth",
        });
      }
    });
  });

  // Add active class to navigation links based on scroll position
  function updateActiveNavLink() {
    const sections = document.querySelectorAll("section[id]");
    const headerHeight = document.querySelector("header").offsetHeight;
    const allNavLinks = document.querySelectorAll(
      '.main-nav .nav-link[href^="#"]',
    );

    let currentSection = "";

    sections.forEach((section) => {
      const sectionTop = section.offsetTop - headerHeight - 100;
      const sectionBottom = sectionTop + section.offsetHeight;

      if (window.scrollY >= sectionTop && window.scrollY < sectionBottom) {
        currentSection = section.getAttribute("id");
      }
    });

    allNavLinks.forEach((link) => {
      link.classList.remove("active");
      if (link.getAttribute("href") === `#${currentSection}`) {
        link.classList.add("active");
      }
    });
  }

  // Event listeners
  window.addEventListener("scroll", function () {
    updateActiveNavLink();
  });

  // Initial calls
  updateActiveNavLink();

  const animationItems = document.querySelectorAll(".animation-item");

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("animate");
          obs.unobserve(entry.target); // ✅ run only once
        }
      });
    },
    { threshold: 0.2 },
  ); // trigger when 20% is visible

  animationItems.forEach((element) => observer.observe(element));

  // Gallery modal functionality
  const modal = document.getElementById("modal");
  const modalImage = document.getElementById("modal-image");
  const closeModal = document.querySelector(".close-modal");
  const modalImages = document.querySelectorAll(".modal-image");

  // Open modal when clicking on gallery images
  modalImages.forEach((img) => {
    img.addEventListener("click", function () {
      modal.style.display = "flex";
      modal.classList.add("show");
      modalImage.src = this.src;
      modalImage.alt = this.alt;
      document.body.style.overflow = "hidden"; // Prevent background scrolling
    });
  });

  if (closeModal) {
    // Close modal when clicking the close button
    closeModal.addEventListener("click", function () {
      closeImageModal();
    });

    // Close modal when clicking outside the image
    modal.addEventListener("click", function (e) {
      if (e.target === modal) {
        closeImageModal();
      }
    });

    // Close modal with Escape key
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && modal.classList.contains("show")) {
        closeImageModal();
      }
    });
  }

  // Function to close the modal
  function closeImageModal() {
    modal.classList.remove("show");
    modal.style.display = "none";
    modalImage.src = "";
    modalImage.alt = "";
    document.body.style.overflow = ""; // Re-enable background scrolling
  }
});
